import { motion } from 'motion/react';
import { ArrowRight, Play } from 'lucide-react';
import { Link } from 'react-router-dom';

export const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/20 rounded-full blur-[128px] animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/20 rounded-full blur-[128px] animate-pulse delay-1000" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="pb-20 md:pb-28"
        >
          <span className="inline-block py-1 px-3 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-mono uppercase tracking-[0.2em] mb-6">
            Akademia Milionerów AI
          </span>
          <h1 className="text-5xl md:text-7xl lg:text-9xl font-display font-bold text-text-main mb-8 leading-[1.1] tracking-tighter">
            <span className="block px-4 pb-2 text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-500">#MNIEJ PRACY</span>
            <span className="block px-4 pb-2 text-transparent bg-clip-text bg-gradient-to-r from-primary via-accent to-primary">#WIĘCEJ PIENIĘDZY</span>
          </h1>
          <p className="text-lg md:text-xl text-text-muted max-w-2xl mx-auto mb-10 leading-relaxed">
            Przestań zgadywać, jak zarabiać w internecie. Wybierz gotową Ścieżkę Kariery z AI i odzyskaj swój czas.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <Link to="/o-akademii" className="group px-8 py-4 bg-primary text-primary-foreground font-bold text-sm uppercase tracking-wider rounded-full hover:bg-primary/90 transition-all shadow-[0_0_30px_rgba(var(--color-primary),0.4)] flex items-center gap-2">
              Dopasuj Ścieżkę Kariery
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <button className="px-8 py-4 bg-transparent border border-border text-text-main font-bold text-sm uppercase tracking-wider rounded-full hover:bg-surface-highlight transition-all flex items-center gap-2">
              <Play className="w-4 h-4 fill-current" />
              Zobacz Wideo
            </button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden lg:flex flex-col items-center gap-2 text-text-muted opacity-50"
        animate={{ y: [0, 5, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <span className="text-[8px] uppercase tracking-[0.3em] font-bold">Przewiń ekran</span>
        <div className="w-[1px] h-8 bg-gradient-to-b from-primary/50 to-transparent" />
      </motion.div>
    </section>
  );
};
